import { StandardMaterial } from "@babylonjs/core/Materials/standardMaterial";

export class OccluderMaterial extends StandardMaterial {
    constructor(name: string, scene?: babylon.Scene) {
        super(name, scene);
        this.metadata = { gltf: { extras: { engeenee: { occluder: {} } } } };
    }
}
